export default class BackButton {
  constructor(elTarget, callbackClick){
    this.elTarget = elTarget
    this.callbackClick = callbackClick

    this.createBackButton()
  }

  createBackButton(){
    jQuery('.mhg-btn-back').remove()

    this.backButton = jQuery(`
      <button type="button" class="mhg-btn-back">
        Back to main menu
      </button>
    `)

    this.elTarget.prepend(this.backButton)
    this.backButton.click((e) => {
      e.preventDefault()
      this.callbackClick(e)
      this.reset()
    })
  }

  reset(){
    this.backButton.remove()
  }

  destroy(){
    this.reset()
  }
}



// WEBPACK FOOTER //
// ./src/custom_menu/back_button.js